"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quickSyncRailgunTransactions = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const graphql_1 = require("./graphql");
const runtime_1 = require("@graphql-mesh/runtime");
const railgun_tx_graph_type_formatters_1 = require("./railgun-tx-graph-type-formatters");
const graph_util_1 = require("../util/graph-util");
const meshes = {};
// 1.5 full trees of commitments
// TODO: This will have to change when we have more than 100k commitments.
const MAX_QUERY_RESULTS = 100000;
const txsSubgraphSourceNameForNetwork = (networkName) => {
    switch (networkName) {
        case shared_models_1.NetworkName.Ethereum:
            return 'txs-ethereum';
        case shared_models_1.NetworkName.EthereumGoerli:
            return 'txs-goerli';
        case shared_models_1.NetworkName.BNBChain:
        case shared_models_1.NetworkName.Polygon:
        case shared_models_1.NetworkName.Arbitrum:
        case shared_models_1.NetworkName.ArbitrumGoerli:
        case shared_models_1.NetworkName.PolygonMumbai:
        case shared_models_1.NetworkName.Railgun:
        case shared_models_1.NetworkName.EthereumRopsten_DEPRECATED:
        case shared_models_1.NetworkName.Hardhat:
            throw new Error('No railgun-transaction subgraph for this network');
    }
};
const quickSyncRailgunTransactions = async (chain, latestGraphID) => {
    const network = (0, shared_models_1.networkForChain)(chain);
    if (!network || !(0, shared_models_1.isDefined)(network.poi)) {
        return [];
    }
    const sdk = getBuiltGraphSDK(network.name);
    const railgunTransactions = await autoPaginatingQuery(async (id) => (await sdk.PoiMessageHashes({
        idLow: id,
    })).transactionInterfaces, latestGraphID ?? '0x00');
    const filteredRailgunTransactions = (0, graph_util_1.removeDuplicatesByID)(railgunTransactions);
    const formattedRailgunTransactions = (0, railgun_tx_graph_type_formatters_1.formatRailgunTransactions)(filteredRailgunTransactions);
    return formattedRailgunTransactions;
};
exports.quickSyncRailgunTransactions = quickSyncRailgunTransactions;
const autoPaginatingQuery = async (query, id, prevResults = []) => {
    const newResults = await query(id);
    if (newResults.length === 0) {
        return prevResults;
    }
    const totalResults = prevResults.concat(newResults);
    const overLimit = totalResults.length >= MAX_QUERY_RESULTS;
    const lastResult = totalResults[totalResults.length - 1];
    const shouldQueryMore = newResults.length === 1000;
    if (!overLimit && shouldQueryMore) {
        return autoPaginatingQuery(query, lastResult.id, totalResults);
    }
    return totalResults;
};
const getBuiltGraphClient = async (networkName) => {
    const meshForNetwork = meshes[networkName];
    if ((0, shared_models_1.isDefined)(meshForNetwork)) {
        return meshForNetwork;
    }
    const sourceName = txsSubgraphSourceNameForNetwork(networkName);
    const meshOptions = await (0, graphql_1.getMeshOptions)();
    const filteredSources = meshOptions.sources.filter(source => {
        return source.name === sourceName;
    });
    if (filteredSources.length !== 1) {
        throw new Error(`Expected exactly one source for network ${networkName}, found ${filteredSources.length}`);
    }
    meshOptions.sources = [filteredSources[0]];
    const mesh = await (0, runtime_1.getMesh)(meshOptions);
    meshes[networkName] = mesh;
    const id = mesh.pubsub.subscribe('destroy', () => {
        meshes[networkName] = undefined;
        mesh.pubsub.unsubscribe(id);
    });
    return mesh;
};
const getBuiltGraphSDK = (networkName, globalContext) => {
    const sdkRequester$ = getBuiltGraphClient(networkName).then(({ sdkRequesterFactory }) => sdkRequesterFactory(globalContext));
    return (0, graphql_1.getSdk)((...args) => sdkRequester$.then(sdkRequester => sdkRequester(...args)));
};
